var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"terms-updated-view"}},[_c('v-content',[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }